import router from '../router'
import VueGtagPlugin from 'vue-gtag'
import Vue from 'vue'

Vue.use(VueGtagPlugin, {
  config: {
    id: process.env.VUE_APP_GTAG_ID,
  },
}, router)
